import { FunctionComponent, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";

import { changeUserPassword } from "../../store/Auth";
import { useMediaQuery } from "react-responsive";
import { useHistory } from "react-router-dom";
interface OtpSideBarProps {
  show: boolean;
  onClose: () => void;
  otp?: string;
}
interface ISignUpInputs {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  termsAgreed: boolean;
  privacyPolicy: boolean;
}
export const UpdatePasswordOtpSideBar: FunctionComponent<OtpSideBarProps> = ({
  show,
  onClose,
  otp,
}) => {
  const isMobileView = useMediaQuery({ maxWidth: 700 });
  const style = { width: show ? isMobileView ? "100%" : "300px" : "0px" };
  const dispatch = useDispatch();
  const history = useHistory();

  const [Otp, setOtp] = useState<string>("");

  const { register, handleSubmit, errors, getValues } = useForm<ISignUpInputs>(
    {}
  );

  const onVerify = async () => {
    try {
      await dispatch(changeUserPassword({currentPassword: localStorage.getItem('cp'), newPassword: localStorage.getItem('np')}, Otp, history));
    }
    catch (e: any) {
        console.log('error in change password api: ', e.response.data.message);
    }
  };
  
  return (
    <div className="sidenav com-font" style={style}>
      <a
        href="javascript:void(0)"
        className="closebtn closex"
        onClick={onClose}
      >
        ×
      </a>
      <div className="col-lg-12">
        <form onSubmit={handleSubmit(onVerify)}>
          <div className="small signintxt">Update Password</div>
          <div className="small signintxt">
            Time to check your email. To continue, please enter the one-time
            code that we sent to your email address to update your password.
          </div>
          <div className="paddsearchfilup">
            <div className="input-group">
              <input
                type="text"
                placeholder="OTP"
                className="form-control"
                name="OTP"
                value={otp}
                onInput={(e) => setOtp((e.target as HTMLInputElement).value)}
              />
            </div>
          </div>
          <div className="paddsearchfilup text-center">
            <button
              className="btn btn-sm btn-default combtnclick btn-block"
              type="submit"
            >
              Submit
            </button>
          </div>
        </form>
       
      </div>
    </div>
  );
};
